import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import { SurveyState } from "./survey.entity";
import { deleteSurveyQuestion, fetchServiceSurveys, insertSurveyQuestion } from "./survey.api";

const initialState: SurveyState = {
  list: [],
  loading: false,
};

export const getServiceSurveys = createAsyncThunk("survey/get", fetchServiceSurveys);

export const createServiceSurvey = createAsyncThunk("survey/create", insertSurveyQuestion);

export const deleteServiceSurvey = createAsyncThunk("survey/delete", deleteSurveyQuestion);

const serviceSurveys = createSlice({
  name: "survey",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getServiceSurveys.pending, (state) => {
        state.loading = true;
      })
      .addCase(getServiceSurveys.rejected, (state) => {
        state.loading = false;
      })
      .addMatcher(isAnyOf(getServiceSurveys.fulfilled, createServiceSurvey.fulfilled, deleteServiceSurvey.fulfilled), (state, action) => {
        state.list = action.payload.data;
        state.loading = false;
      });
  },
});

export default serviceSurveys.reducer;
